<template>
  <b-badge :variant="statusClass" v-b-tooltip :title="statusText" @click="$emit('click')"></b-badge>
</template>

<script>
  export default {
    name: 'printer-status',
    props: ['printer'],
    computed: {
      statusClass() {
        let className = '';
        switch (this.printer.state) {
          case 'idle':
            className = this.printer.build_tray_not_clear==='t' ? '-gray status' : '-green status';
            break;
          case 'downloading':
          case 'paused':
          case 'manual_control':
            className = '-orange status';
            break;
          case 'Virtual':
            className = '-violet status';
            break;
          case 'offline':
            className = '-gray status';
            break;
          case 'heating':
            className = '-gray status';
            break;
          default: className = '-blue status';
        }
        if (this.printer.state === 'printing' ||
          this.printer.state === 'heating' ||
          this.printer.state === 'paused') {
          className += ' badge--progress status';
        }

        return className;
      },
      statusText() {
        if (this.printer.state === 'idle' && this.printer.build_tray_not_clear==='t') {
          return this.$t('printers.status.bed_not_clear');
        }
        if (this.printer.state === 'printing' ||
          this.printer.state === 'heating' ||
          this.printer.state === 'paused') {
          return this.$t('printers.status.' + this.printer.state) + ' ' + this.printer.percent + '%';
        }

        return this.$t('printers.status.' + this.printer.state);
      }
    }
  }
</script>

<style lang="scss">
  .badge.status {
    transition: .3s;
    font-size: 0;
    border-radius: 16px;
    height: 10px;
    width: 10px;
    margin: 0 2px 0 0;
  }
</style>
